import React, { memo } from 'react';
import { Switch, Route, NavLink, useRouteMatch, Redirect } from 'react-router-dom';
import classNames from 'classnames';
import KeepAlive, { useAliveController, useActivate, useUnactivate } from 'react-activation';
import styles from './EductionTabs.module.less';
import EduRecommend from '../EduRecommend/EduRecommend';
import EduCategory from '../EduCategory/EduCategory';
import EduMine from '../EduMine/EduMine';
import { useHistory, useLocation } from 'react-router-dom';
import { CONTEXT } from '../../../config';

const tabs = [
  {
    name: '精选',
    path: 'recommend',
    component: EduRecommend,
    icon: 'icon-recommend1_15',
  },
  {
    name: '分类',
    path: 'category',
    icon: 'icon-category1_15',
    component: EduCategory,
  },
  {
    name: '我的',
    path: 'mine',
    icon: 'icon-edu_mine',
    component: EduMine,
  },
];
export default memo(() => {
  const { path, url } = useRouteMatch();
  const history = useHistory();
  const { drop } = useAliveController();

  return (
    <div className={styles.education}>
      <div className={styles.nav_h_container}>
        <div className={styles.nav_h}>
          <div className={styles.nav}>
            {tabs.map(tab => (
              <NavLink to={`${url}/${tab.path}`} key={tab.path} activeClassName={styles.active}>
                <div className={classNames(styles.item)}>
                  <i data-url={tab.url} className={classNames('iconfont', tab.icon, styles.icon)} />
                  <div className={styles.nav_text}>{tab.name}</div>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
      </div>
      <Switch>
        <Route exact path={`${url}/recommend`}>
          <EduRecommend></EduRecommend>
        </Route>
        <Route exact path={`${url}/category`}>
          <EduCategory></EduCategory>
        </Route>
        <Route exact path={`${url}/mine`}>
          <EduMine></EduMine>
        </Route>
        <Redirect to={`${CONTEXT}/education/recommend`}></Redirect>
      </Switch>
    </div>
  );
});
